import { IBaseComponent } from "../models/formFields.interfaces";
import { AbstractFormComponent } from "./AbstractFormComponent";

// TODO(i18n): This component inherits error rendering from AbstractFormComponent.
// Error messages, help text, warning titles/text, and tooltip text passed as props
// should be translated by the caller before being passed to this component.
// Verify all usage sites translate these strings appropriately.
export class NonFieldErrors extends AbstractFormComponent<
    IBaseComponent,
    Record<string, never>
> {}
